import 'bootstrap/dist/css/bootstrap.min.css';
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Home } from './pages/Home';
import { Contact } from './pages/Contact';
import { Education } from './pages/Education';
import { Certificates } from './pages/Certificates'
import { Projects } from './pages/Projects';
import { Skills } from './pages/Skills';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/journey" element={<Education />} />
        <Route path="/milestones" element={<Certificates />} />
        <Route path="/creations" element={<Projects />} />
        <Route path="/toolkit" element={<Skills />} />
      </Routes>
    </Router>
  );
}

export default App;
